import toggleButtonClasses from "@mui/material/ToggleButton/toggleButtonClasses";
export const MuiToggleButtonGroupTheme = (dt) => {
    return {
        styleOverrides: {
            root: {
                padding: dt.space.stack.xSmall3,
                gap: "2px",
                flexWrap: "wrap",
                borderRadius: dt.button.shape.borderRadius,
                [`.${toggleButtonClasses.root}`]: {
                    flexGrow: 0,
                    flexShrink: 0,
                    marginLeft: "unset",
                    borderRadius: dt.button.shape.borderRadius,
                },
            },
        },
    };
};
